export type LeadDelivery = {
  ok: boolean;
  crmDelivered: boolean;
  customerPackQueued: boolean;
  brokerNotified: boolean;
};

export function asBoolean(value: unknown): boolean {
  return value === true;
}

export function parseLeadDelivery(raw: unknown): LeadDelivery | null {
  if (!raw || typeof raw !== "object") return null;
  const row = raw as Record<string, unknown>;
  if (typeof row.ok !== "boolean") return null;
  return {
    ok: row.ok,
    crmDelivered: asBoolean(row.crmDelivered) || asBoolean(row.forwarded),
    customerPackQueued: asBoolean(row.customerPackQueued) || asBoolean(row.emailed),
    brokerNotified: asBoolean(row.brokerNotified),
  };
}

export function packDeliverySucceeded(kind: "script" | "switch", delivery: LeadDelivery): boolean {
  if (!delivery.ok) return false;
  if (kind === "script") return delivery.customerPackQueued;
  return delivery.crmDelivered || delivery.brokerNotified;
}

export function packDeliveryPartial(kind: "script" | "switch", delivery: LeadDelivery): boolean {
  if (kind !== "script") return false;
  if (delivery.customerPackQueued) return false;
  return delivery.crmDelivered || delivery.brokerNotified;
}
